import { render, staticRenderFns } from "./KYCForm.vue?vue&type=template&id=17e8ffa8&scoped=true"
import script from "./KYCForm.vue?vue&type=script&lang=js"
export * from "./KYCForm.vue?vue&type=script&lang=js"
import style0 from "./KYCForm.vue?vue&type=style&index=0&id=17e8ffa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e8ffa8",
  null
  
)

export default component.exports